/* eslint-disable import/prefer-default-export */
import postData from "../api/postData";

let user = {};
function getUser() {
  const userString = localStorage.getItem("currentUser");
  user = JSON.parse(userString);
}

export async function getUploadUrl(data) {
  getUser();
  const result = await postData({
    path: "/scholarshipBackend/upload-url",
    body: data, // {fileName, containerNameEnd}
    accessToken: user.accessToken,
  });
  if (!result?.message?.error) {
    return result;
  }
  return false;
}

export async function addDocumentToApplication(data) {
  getUser();
  const result = await postData({
    path: "/students/add-document-to-application",
    body: data,
    accessToken: user.accessToken,
  });
  if (!result?.message?.error) {
    return result;
  }
  return false;
}

export async function getDownloadUrl(data) {
  getUser();
  const result = await postData({
    path: "/scholarshipBackend/download-url",
    body: data, // {blobName, containerNameEnd}
    accessToken: user.accessToken,
  });
  if (!result?.message?.error) {
    return result;
  }
  return false;
}
